import styled from "styled-components";

const Tabela = styled.table`
    width: 90%;
    justify-content: center;
    text-align: center;
    border-collapse: collapse;
    margin: auto;
    margin-top: 10px;
    margin-bottom: 40px;
    overflow-x: auto;
`
const LinhaTabela = styled.tr`
    border-bottom: 1px solid lightgray;
    height: ${props => props.$tamanho || "40px"};
`
const ColunaTabela = styled.td`
    width: ${props => props.$tamanho || "auto"};
    color: ${props => props.$cor || "#252525"};
    font-size: ${props => props.$tamFonte || "inherit"};
    font-weight: ${props => props.$bold || "normal"};

    .Icone {
        margin: 5px 5px 0 0;
        padding: 0;
    }
`

// Variável com os tipos de ingressos a serem mostrados na tabela
const tiposIngressos = [
    { tipo: "individuais", label: "Individuais" },
    { tipo: "promocionaisExcursao", label: "Excursão" },
    { tipo: "promocionaisEscolar", label: "Escolar"},
    { tipo: "individuaisOnline", label: "Indiv. online"},
    { tipo: "infantis", label: "Infantis" },
    { tipo: "infantisOnline", label: "Inf. online" },
    { tipo: "cortesias", label: "Cortesias" },
    { tipo: "parksnet", label: "PARKSNET" },
    { tipo: "promocionais", label: "Prom." },
    { tipo: "promocionaisOnline", label: "Prom. online" }
];

export function TabelaPorDia(dados) {
    try {
        return (
            <Tabela>
                <LinhaTabela>
                    <ColunaTabela $bold="bold">Dia</ColunaTabela>
                    <ColunaTabela $bold="bold">Total</ColunaTabela>
                    {tiposIngressos.map( item => {
                        return (<ColunaTabela $bold="bold">{item.label}</ColunaTabela>)
                    })}
                </LinhaTabela>
                {dados.dias.map((dia, indice) => {
                    const totalDia = tiposIngressos.reduce( (total, item) => total + dados.quantidade[indice][item.tipo], 0);
                    
                    return <LinhaTabela>
                        <ColunaTabela>{dia.split("-")[2]}/{dia.split("-")[1]}/{dia.split("-")[0]}</ColunaTabela>
                        <ColunaTabela>{totalDia}</ColunaTabela>
                        {tiposIngressos.map( item => {
                            return (<ColunaTabela>{dados.quantidade[indice][item.tipo]}</ColunaTabela>)
                        })}
                    </LinhaTabela>
                })}
            </Tabela>
        );
    } catch (e) {
        console.log(e.message);
        return <></>
    }
}